import { useQuery } from 'data-fetching-client';
import { GET_PAGES_BY_ID } from 'flow-doctor-lib/queries/ContentQueries';
const useContentPage = ({
  portalId,
  pageId
}, {
  skip
} = {}) => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_PAGES_BY_ID, {
    variables: {
      portalId,
      ids: [pageId]
    },
    skip
  });
  const dataToReturn = data ? data.pagesById.objects.find(page => page.analyticsPageId === pageId) : null;
  return {
    data: dataToReturn,
    loading,
    error
  };
};
export default useContentPage;